import { supabase } from '../lib/supabaseClient';

export interface SeederConfiguration {
  id: string;
  seeder_type: 'eventbrite' | 'meetup' | 'getyourguide';
  seeder_name: string;
  apify_actor_id: string;
  is_active: boolean;
  max_fetch_limit: number;
  max_insert_limit: number;
  default_days_ahead: number;
  last_run_at?: string;
  last_run_stats?: {
    success: boolean;
    daysAhead: number;
    dateFrom: string;
    dateTo: string;
    fetched: number;
    inserted: number;
    skipped_out_of_range: number;
    skipped_duplicate: number;
    skipped_validation: number;
    skipped_major_event: number;
    skipped_experience_filter?: number;
    errors: any[];
    validationErrors: any[];
  };
  created_at: string;
  updated_at: string;
}

export async function getSeederConfigurations(): Promise<SeederConfiguration[]> {
  const { data, error } = await supabase
    .from('seeder_configurations')
    .select('*')
    .order('seeder_type', { ascending: true });

  if (error) {
    console.error('Error fetching seeder configurations:', error);
    throw error;
  }

  return data || [];
}

export async function getSeederConfiguration(seederType: string): Promise<SeederConfiguration | null> {
  const { data, error } = await supabase
    .from('seeder_configurations')
    .select('*')
    .eq('seeder_type', seederType)
    .single();

  if (error) {
    if (error.code === 'PGRST116') {
      return null; // No row found
    }
    console.error('Error fetching seeder configuration:', error);
    throw error;
  }

  return data;
}

export async function updateSeederConfiguration(
  id: string,
  updates: Partial<Omit<SeederConfiguration, 'id' | 'seeder_type' | 'created_at' | 'updated_at'>>
): Promise<void> {
  const { error } = await supabase
    .from('seeder_configurations')
    .update(updates)
    .eq('id', id);

  if (error) {
    console.error('Error updating seeder configuration:', error);
    throw error;
  }
}

export async function toggleSeederActive(id: string, isActive: boolean): Promise<void> {
  const { error } = await supabase
    .from('seeder_configurations')
    .update({ is_active: isActive })
    .eq('id', id);

  if (error) {
    console.error('Error toggling seeder active status:', error);
    throw error;
  }
}
